<script></script>

<div class="main">
    <div class="title">
        ECOSYSTEM
    </div>
    <div class="img-wrapper">
        <img width="100%" height="100%" src="images/web3_pages/ecosystem.png" alt="ecosystem">
    </div>
    <div class="detail">
        A community of creators with over 100+ work personas and 
        <span>incentivized through FNFT rewards.</span>
    </div>
</div>

<style>
    .main{
        width: 33.854vw;
        height: 47.917vw;
        background-color: #ffffff;
        box-shadow: -0.208vw 0.208vw 0.417vw rgba(0, 0, 0, 0.5);
        border-radius: 2.083vw;
        position: relative;
        font-family: 'Montserrat';
        font-style: normal;
        color: #FF007F;
    }
    .title{
        font-weight: 900;
        font-size: 2.604vw;
        line-height: 74.5%;
        text-align: center;
        position: absolute;
        top: 3.382vw;
        width: 100%;
    }
    .img-wrapper{
        position: absolute;
        top: 9.111vw;
        left: 4.792vw;
        width: 24.219vw;
        height: 24.219vw;
    }
    .img-wrapper img{
        pointer-events: none;
    }
    .detail{
        width: 23.385vw;
        position: absolute;
        top: 37.497vw;
        left: 0;
        right: 0;
        margin: auto;
        font-weight: 500;
        font-size: 1.563vw;
        line-height: 100%;
        text-align: center;
    }
    .detail span{
        font-weight: 800;
    }
</style>